import { BTabs, BTab } from 'bootstrap-vue';

//
var script = {
  name: "CustomTab",
  components: {
    BTabs
  },
  props: {
    navClass: {
      type: String,
      default: () => ''
    },
    defaultActiveTab: {
      type: Number,
      default: () => null
    }
  },

  data() {
    return {
      tabModel: null,
      theme: {}
    };
  },

  computed: {
    navContainerClass() {
      return `custom-tab-container ${this.navClass}`;
    }

  },
  watch: {
    defaultActiveTab: {
      immediate: true,

      handler(newVal) {
        if (newVal) this.tabModel = newVal;
      }

    },
    tabModel: {
      immediate: true,

      handler(newVal, oldVal) {
        if (oldVal != newVal) {
          this.$emit("input", newVal);
        }
      }

    }
  },
  methods: {
    previous() {
      this.tabModel = this.tabModel - 1;
      this.scrollTo(-120);
    },

    next() {
      this.tabModel = this.tabModel + 1;
      this.scrollTo(120);
    },

    scrollTo(scrollPixels) {
      let element = this.$el.querySelector(".custom-tab-container");
      const scrollPos = element.scrollLeft;
      element.scrollLeft = scrollPos + scrollPixels;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "custom-tab"
  }, [_c('em', {
    staticClass: "custom-tab-cursors fas fa-chevron-left nav-left-icon",
    on: {
      "click": function ($event) {
        return _vm.previous();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-wrapper"
  }, [_c('b-tabs', {
    attrs: {
      "no-nav-style": true,
      "nav-class": _vm.navContainerClass
    },
    model: {
      value: _vm.tabModel,
      callback: function ($$v) {
        _vm.tabModel = $$v;
      },
      expression: "tabModel"
    }
  }, [_vm._t("default")], 2)], 1), _vm._v(" "), _c('em', {
    staticClass: "custom-tab-cursors fas fa-chevron-right nav-right-icon",
    on: {
      "click": function ($event) {
        return _vm.next();
      }
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-7642c372_0", {
    source: ".custom-tab[data-v-7642c372]{--tab-border-color:#e2e2e2;--nav-link-color:#727272;--tab-active-color:#2db782;--tab-font-size:14px;display:flex;align-items:flex-start}.custom-tab-cursors[data-v-7642c372]{display:none;cursor:pointer;color:var(--tab-active-color);margin-top:20px!important}@media only screen and (max-width:768px){.custom-tab-cursors[data-v-7642c372]{display:block}}.custom-tab-cursors.nav-left-icon[data-v-7642c372]{margin-right:10px}.custom-tab-cursors.nav-right-icon[data-v-7642c372]{margin-left:10px!important}.custom-tab .tabs[data-v-7642c372]{flex-grow:1}.custom-tab .tab-wrapper[data-v-7642c372]{flex-grow:1;width:80%}.custom-tab[data-v-7642c372]  .custom-tab-container{border-bottom:1px solid var(--tab-border-color);margin-left:20px;margin-right:20px}@media only screen and (max-width:768px){.custom-tab[data-v-7642c372]  .custom-tab-container{display:inline-block;margin:0 0 1em;white-space:nowrap;width:100%;overflow:auto;overflow-y:hidden}}@media only screen and (max-width:768px){.custom-tab[data-v-7642c372]  .custom-tab-container .nav-item{display:inline-block!important;width:auto}}.custom-tab[data-v-7642c372]  .custom-tab-container .nav-item .nav-link{font-size:var(--tab-font-size);padding-right:70px;color:var(--nav-link-color);padding-left:35px}.custom-tab[data-v-7642c372]  .custom-tab-container .nav-item .nav-link.active{border-bottom:3px solid var(--tab-active-color);color:var(--tab-active-color);font-weight:700}@media only screen and (max-width:768px){.custom-tab[data-v-7642c372]  .custom-tab-container .nav-item .nav-link.active{border-bottom:2px solid var(--tab-active-color)}}.custom-tab[data-v-7642c372]  .custom-tab-container .nav-item .nav-link.active:after{content:unset}@media only screen and (max-width:768px){.custom-tab[data-v-7642c372]  .custom-tab-container .nav-item .nav-link{font-size:12px;padding-bottom:10px;padding-right:27px!important;width:100%}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-7642c372";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

//
var script$1 = {
  name: "CustomTab",
  components: {
    BTab
  },
  props: {
    lazy: {
      type: Boolean,
      default: () => true
    },
    title: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: () => false
    },
    navItemClass: {
      type: [Object, String],
      default: () => ''
    },
    navLinkClass: {
      type: [Object, String],
      default: () => ''
    }
  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('b-tab', {
    staticClass: "custom-tab-item",
    attrs: {
      "lazy": _vm.lazy,
      "title": _vm.title,
      "active": _vm.active,
      "title-link-class": _vm.navLinkClass,
      "title-item-class": _vm.navItemClass,
      "tag": "div"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click', $event);
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

// Import vue component

const install = function installCustomTab(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomTab', __vue_component__);
};

const install2 = function installCustomTabItem(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('CustomTabItem', __vue_component__$1);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install;
__vue_component__$1.install = install2; // Export component by default

const CustomTab = __vue_component__;
const CustomTabItem = __vue_component__$1;

export { CustomTab, CustomTabItem };
